/* Exact-product paid back-personalization properties and validation. */
if (typeof customElements !== 'undefined' && !customElements.get('orocuff-bracelet-custom-center')) {
  customElements.define('orocuff-bracelet-custom-center', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.productId !== '10502576767293' ||
          this.dataset.productHandle !== 'psalm-121-1-2-hand-stitched-mountain-cross-leather-cuff-thorn-detail') return;
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.mainForm = document.getElementById(this.dataset.formId);
      this.panel = this.querySelector('[data-obcc-panel]');
      this.nameInput = this.querySelector('[data-obcc-name]');
      this.numberInput = this.querySelector('[data-obcc-number]');
      this.error = this.querySelector('[data-obcc-error]');
      this.personalizedIds = new Set((this.dataset.personalizedIds || '').split(',').filter(Boolean));
      this.variantIds = new Set((this.dataset.variantIds || '').split(',').filter(Boolean));
      if (!this.mainForm || !this.panel || !this.nameInput || !this.numberInput) return;

      this.nameInput.addEventListener('input', () => {
        const value = this.nameInput.value.toUpperCase().replace(/[^A-Z]/g, '').slice(0, 8);
        if (this.nameInput.value !== value) this.nameInput.value = value;
        this.sync();
      }, options);
      this.numberInput.addEventListener('input', () => {
        const value = this.numberInput.value.replace(/[^0-9]/g, '').slice(0, 8);
        if (this.numberInput.value !== value) this.numberInput.value = value;
        this.sync();
      }, options);
      document.addEventListener('afterVariantChanged', event => {
        if (this.variantIds.has(String(event.detail?.variant?.id))) queueMicrotask(() => this.sync());
      }, options);
      document.addEventListener('submit', event => {
        if (!this.matchesProductForm(event.target) || this.multiMode || !this.personalized()) return;
        this.sync();
        if (this.nameInput.value || this.numberInput.value) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.error.textContent = 'Enter a left name, a right number, or both—or choose No Personalization.';
        this.error.hidden = false;
        this.panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.nameInput.focus();
      }, { ...options, capture: true });
      document.addEventListener('formdata', event => {
        if (!this.matchesProductForm(event.target)) return;
        event.formData.delete('properties[Left Name]');
        event.formData.delete('properties[Right Number]');
        if (!this.personalized() || this.multiMode) return;
        if (this.nameInput.value) event.formData.set('properties[Left Name]', this.nameInput.value);
        if (this.numberInput.value) event.formData.set('properties[Right Number]', this.numberInput.value);
      }, { ...options, capture: true });
      this.sync();
      this.dataset.ready = 'true';
    }

    disconnectedCallback() { this.controller?.abort(); }
    personalized() {
      return this.personalizedIds.has(String(this.mainForm?.querySelector('[name="id"]')?.value));
    }
    isPersonalizedVariantId(id) { return this.personalizedIds.has(String(id)); }
    matchesProductForm(form) {
      return form instanceof HTMLFormElement && form.dataset.type === 'add-to-cart-form' &&
        this.variantIds.has(String(form.querySelector('[name="id"]')?.value));
    }
    setMultiMode(active) {
      this.multiMode = !!active;
      this.sync();
    }
    sync() {
      const personalized = this.personalized();
      const active = personalized && !this.multiMode;
      this.panel.hidden = !active;
      this.querySelector('[data-obcc-multi]').hidden = !this.multiMode;
      this.nameInput.disabled = !active;
      this.numberInput.disabled = !active;
      this.nameInput.setCustomValidity('');
      this.numberInput.setCustomValidity('');
      if (!personalized) {
        this.nameInput.value = '';
        this.numberInput.value = '';
      }
      this.error.hidden = true;
      const dynamic = this.closest('.oc-purchase')?.querySelector('.oc-purchase__dynamic');
      if (dynamic) dynamic.dataset.setHidden = String(this.multiMode);
      document.querySelectorAll('sticky-cart').forEach(sticky => {
        if (sticky.dataset.form === this.dataset.formId) sticky.classList.toggle('obcc-sticky-hidden', personalized || this.multiMode);
      });
    }
  });
}

/* Keep Shopify Chat clear of this product's mobile sticky purchase bar. */
if (location.pathname === '/products/psalm-121-1-2-hand-stitched-mountain-cross-leather-cuff-thorn-detail') {
  let obccChatAttempts = 0;
  const installObccChatFix = () => {
    obccChatAttempts += 1;
    const chat = document.querySelector('shopify-chat');
    const runtime = chat?.shadowRoot?.querySelector('shopify-agent-runtime');
    const root = runtime?.shadowRoot;
    if (!root) {
      if (obccChatAttempts < 60) setTimeout(installObccChatFix, 250);
      return;
    }
    if (root.getElementById('obcc-product-chat-fix')) return;
    const style = document.createElement('style');
    style.id = 'obcc-product-chat-fix';
    style.textContent = `
      @media (max-width: 749px) {
        .activator-nudge.activator-nudge--right {
          right: max(8px, env(safe-area-inset-right)) !important;
          bottom: 132px !important;
          width: 46px !important;
        }
        .activator {
          box-sizing: border-box !important;
          width: 46px !important;
          min-width: 46px !important;
          height: 46px !important;
          padding: 0 !important;
          border-radius: 999px !important;
          justify-content: center !important;
        }
        .activator__label { display: none !important; }
      }
      @media (max-width: 340px) {
        .activator-nudge.activator-nudge--right { bottom: 192px !important; }
      }
    `;
    root.append(style);
  };
  installObccChatFix();
}
